/* eslint-disable */
import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import Chart from 'chart.js';
import darkGreenCircle from './../../images/dark_green_circle.png';
import darkPurpleCircle from './../../images/dark_purple_circle.png';
import lightGreenCircle from './../../images/light_green_circle.png';
import { get_apm_dashboard_details, getCurrentScenarioRunningDetails, killAndTerminateSelectedInstance } from "../UserFunctions"
import Button from '@material-ui/core/Button'
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap"
import { Doughnut } from 'react-chartjs-2'
import { Link } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb'


class apm_dashboard extends Component {
    constructor(props) {
        super(props)
        this.handleView = this.handleView.bind(this);
        this.closePopupModal = this.closePopupModal.bind(this);
        this.canvasRef = React.createRef();
        this.label = [
            "Completed",
            "Processing",
            "Pending"
        ]
        this.state = {
            togglePopup: false,
            viewSelectedRow: undefined,
            killSelectedRow: undefined,
            killInstanceValue: undefined,
            value: '',
            instance_details: [],
            scn_grp_count: 0,
            total_scn: 0,
            total_scenarios:0,
            // equal: -1,
            scenario_details: [],
            // exec_time_min: 0,
            // exec_time_hrs: 0,
            // exec_time_days: 0,
            chart: [],
            chart1: []
        }
    }

    componentDidUpdate() {
        this.featureChart.data.labels = this.label;
        this.featureChart.data.datasets[0].data = this.state.chart;
        this.featureChart.update();
    }
    handleKillInstancePopup(row) {
        var count = 0
        var index = undefined
        this.state.instance_details.map((currElement, index_value) => {
            if (currElement.instance_id === row.instance_id) {
                index = index_value
                count = count + 1
            }
        })
        this.setState((prevState) => {
            return {
                ...prevState,
                togglePopup: true,
                killSelectedRow: index.toString(),
                killInstanceValue: row
            }
        })
    }
    handleKillInstance(row) {
        var count = 0
        var index = undefined

        console.log("killSelectedRow -->", this.state.killInstanceValue)
        this.state.instance_details.map((currElement, index_value) => {
            if (currElement.instance_id === this.state.killInstanceValue.instance_id) {
                index = index_value
                count = count + 1
            }
        })
        const payload = {
            instance_id: this.state.killInstanceValue.instance_id,
        }
        console.log("row.instance_id", row.instance_id)
        killAndTerminateSelectedInstance('/aws/ec2/kill_and_terminate_instances_from_ui', payload)
        this.closePopupModal()
    }

    handleView(row) {
        var count = 0
        var index = undefined
        this.state.instance_details.map((currElement, index_value) => {
            if (currElement.instance_id === row.instance_id) {
                index = index_value
                count = count + 1
            }
        })
        this.setState({
            row_details: row
        })
        this.setState((prevState) => {
            return {
                ...prevState,
                togglePopup: true,
                viewSelectedRow: index.toString(),
            }
        })
        const payload = {
            instance_id: row.instance_id,
        }
        getCurrentScenarioRunningDetails('fetch_current_scenario_running_details', payload).then(response => {
            if (response.data) {
                this.setState({
                    chart1: response.data['chart_data1']
                })
            }
        })
    }

    closePopupModal() {
        this.setState((prevState) => {
            return {
                ...prevState,
                togglePopup: false,
                viewSelectedRow: undefined,
                killSelectedRow: undefined
            }
        })
    }

    componentDidMount() {

        get_apm_dashboard_details('/apm_filedashboard').then(
            (response) => {
                console.log("apm response--------------------------->", response)
                this.setState({
                    instance_details: response.data['docker_details'],
                    scn_grp_count: response.data['scn_grp_count'],
                    total_scn: response.data['total_scn'],
                    total_scenarios:response.data['total_scenarios'],
                    // exec_time_min:response.data['total_scn'] * 3,
                    // exec_time_hrs:(response.data['total_scn'] * 3)/60,
                    // exec_time_days:(((response.data['total_scn'] * 3)/60)/24).toFixed(2),
                    // current_time:response.data['current_time'],
                    scenario_details: response.data['scenario_details'],
                    chart: response.data['chart_data']
                })
            })
        this.featureChart = new Chart(this.canvasRef.current, {
            type: 'doughnut',
            options: {
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                responsive: true
            },
            data: {
                labels: this.label,
                datasets: [{
                    data: this.state.chart,
                    backgroundColor: ['#428003', '#622AD8', '#CBFF68']
                }]
            }
        });
    }

    render() {
        const customStyles = {
            rows: {
                style: {
                    minHeight: '72px',
                }
            },
            headCells: {
                style: {
                    fontWeight: "bold",
                    fontSize: "1rem",
                    backgroundColor: "white",
                    padding: ".75rem",
                    verticalAlign: "top",
                    borderTop: "1px solid #e9ecef",
                    borderBottom: "5px solid #753DFF",
                    justifyContent: "center"
                },
            },
            cells: {
                style: {
                    backgroundColor: "#C7C9FF",
                    fontSize: "0.9rem",
                    textAlign: "center",
                    verticalAlign: "top",
                    borderTop: "5px solid white",
                    justifyContent: "center"
                },
            },
        };

        // const data = [{ groupid: 1, groupname:'Group 1', total_scenario: 20 } ,{ groupid: 2,  groupname:'Group 1', total_scenario: 20 } ,{ groupid: 3,  groupname:'Group 1', total_scenario: 20 },{ groupid: 4, groupname:'Group 1', total_scenario: 20 },{ groupid: 5, groupname:'Group 1', total_scenario: 20 }];
        const inst_data = this.state.instance_details
        const inst_columns = [
            {
                name: 'Instance Id',
                selector: 'instance_id',
                grow: 2,
                cell: row => <div style={{ flexWrap: 'wrap' }}>{row['instance_id']}</div>
            },
            {
                name: 'Container Name',
                selector: 'container_name'
            }, {
                name: 'Topology Tag Name',
                selector: 'topology_tag_name',
                sortable: true
            },
            //            {
            //                name: 'View Graph',
            //                selector: 'View_Graph',
            //                sortable: true,
            //                cell: row => <div data-tag="allowRowEvents">
            //                <button className="btn"
            //                style={{ marginLeft : "1px" }}
            //                onClick={ () =>{this.handleView(row)}}
            //                data-toggle="tooltip" data-placement="top" title="View">
            //                View
            //                </button>
            //                </div>
            //            },
            //            {
            //                name: 'Kill Instance',
            //                selector: 'kill_instance',
            //                sortable: true,
            //                cell: row => <div data-tag="allowRowEvents">
            //                <button className="btn"
            //                style={{ marginLeft : "1px" }}
            //                onClick={ () =>{this.handleKillInstancePopup(row)}}
            //                data-toggle="tooltip" data-placement="top" title="Kill">
            //                    <i className="fa fa-times"></i>
            //                </button>
            //                </div>
            //            },
        ]

        const data = this.state.scenario_details
        const columns = [
            {
                name: 'Group',
                selector: 'groupid',
                sortable: true,
            },
            {
                name: 'Group Name',
                selector: 'groupname',
                sortable: true,
                right: true,
                cell: row => <div style={{ flexWrap: 'wrap' }}>{row['groupname']}</div>
            },
            {
                name: 'Total Scenarios',
                selector: 'total_scenario',
                sortable: true,
                right: true,
            },
        ];
        function refreshPage() {
            window.location.reload(false);
        }
        return (
            <div className="container">
                <Breadcrumb>
                    <Breadcrumb.Item href="">
                        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        <Link to='/welcome'>Welcome</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=""  >
                        <Link to='/close_loop'>Close loop</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="/apm_dashboard" active >
                        Apm Dashboard
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="row">
                    <div className="col-md-12" style={{ textAlign: "center" }}>
                        <h1>SCENARIO STATUS DASHBOARD</h1>
                    </div>
                    <Button
                        className="btn btn-light" onClick={refreshPage}
                        style={{
                            marginRight: "0.1rem",
                            border: "0px",
                            color: "white",
                            backgroundColor: '#753DFF'
                        }}
                        data-toggle="tooltip" data-placement="top" title="Refresh Dashboard">
                        Refresh Dashboard</Button>
                    {/* <button onClick={refreshPage} >Refresh Dashboard</button> */}
                    <Link to="/apm_file_list" className="nav-link" >
                        <Button
                            className="btn btn-light"
                            style={{
                                marginRight: "0.1rem",
                                border: "0px",
                                color: "white",
                                backgroundColor: '#753DFF'
                            }}
                            data-toggle="tooltip" data-placement="top" title="APM file">
                            APM File List</Button>
                    </Link>

                    {this.state.viewSelectedRow != undefined ?
                        <Modal isOpen={this.state.viewSelectedRow >= 0}
                            viewSelectedRow={this.state.viewSelectedRow}>

                            <ModalHeader
                                style={{ color: "#753DFF" }}>
                                View Graph
                            </ModalHeader>
                            <ModalBody>
                                <div className="form-group">
                                    <div>
                                        <div>
                                            <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap" }}>
                                                <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                                    <a style={{ paddingLeft: "4%" }} className="text-left">
                                                        <img src={darkGreenCircle} /> Completed : {this.state.chart1[0]}
                                                    </a>
                                                </div>
                                            </div>
                                            <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap", paddingRight: '2%' }}>
                                                <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                                    <a style={{ paddingLeft: "10%" }} className="text-left">
                                                        <img src={darkPurpleCircle} /> Processing : {this.state.chart1[1]}
                                                    </a>
                                                </div>
                                            </div>
                                            <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap", paddingRight: "2%" }}>
                                                <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                                    <a style={{ paddingLeft: "10%" }} className="text-left">
                                                        <img src={lightGreenCircle} /> Pending : {this.state.chart1[2]}
                                                    </a>
                                                </div>
                                            </div>
                                            <Doughnut
                                                data={{
                                                    labels: this.label,
                                                    datasets: [
                                                        {
                                                            data: this.state.chart1,
                                                            backgroundColor: ['#428003', '#622AD8', '#CBFF68']
                                                        }]
                                                }}
                                                height={120}
                                                width={120}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                {this.state.togglePopup ? <Button className="btn" style={{ backgroundColor: "#753DFF" }} onClick={this.closePopupModal}>Close</Button> : undefined}
                            </ModalFooter>
                        </Modal> : undefined}
                    {this.state.killSelectedRow != undefined ?
                        <Modal isOpen={this.state.killSelectedRow >= 0}
                            killSelectedRow={this.state.killSelectedRow}>
                            <ModalHeader
                                toggle={this.closePopupModal}
                                style={{ backgroundColor: "#753DFF" }}>
                            </ModalHeader>
                            <ModalBody>
                                <p>Do you want to kill instanace ?</p>
                            </ModalBody>
                            <ModalFooter>
                                <Button className="btn" style={{ marginLeft: "70%", backgroundColor: "#753DFF" }} onClick={(e) => this.handleKillInstance(e)}>Yes</Button>
                                {this.state.togglePopup ? <Button className="btn" style={{ backgroundColor: "#753DFF" }} onClick={this.closePopupModal}>No</Button> : undefined}
                            </ModalFooter>
                        </Modal> : undefined
                    }
                </div>
                <div className="row" style={{ paddingTop: "6%" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                        Instance Information
                                    </div>
                                    <div className="card-body">
                                        {/* instance_id : "i-03e8d8ab-a11a-43c1-a4c4-5a655f2c84e1 | ip_address :127.0.0.1| topology_tag_name :testing_partial_pull| */}
                                        <DataTable
                                            className="dataTables_wrapper"
                                            columns={inst_columns}
                                            customStyles={customStyles}
                                            data={inst_data}
                                            defaultSortField="topology_tag_name"
                                            defaultSortAsc={true}
                                            pagination
                                            highlightOnHover
                                            setFilter
                                            paginationPerPage={5}
                                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                        // paginationRowsPerPageOptions="5"
                                        >
                                        </DataTable>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                Scenario and Group Data
                                            </div>
                                            <div className="card-body">
                                                <ul>
                                                    <li>
                                                        Total Ongoing Scenario Groups : {this.state.scn_grp_count}
                                                    </li>
                                                    <li>
                                                        Total Ongoing Scenarios : {this.state.total_scn}
                                                    </li>
                                                    <li>
                                                        Total Scheduled Scenarios for Execution: {this.state.total_scenarios}
                                                    </li>
                                                </ul>
                                                <div>
                                                    <DataTable
                                                        className="dataTables_wrapper"
                                                        columns={columns}
                                                        customStyles={customStyles}
                                                        data={data}
                                                        defaultSortField="groupid"
                                                        defaultSortAsc={true}
                                                        pagination
                                                        highlightOnHover
                                                        setFilter
                                                        paginationPerPage={5}
                                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                                    // paginationRowsPerPageOptions="5"
                                                    >
                                                    </DataTable>
                                                </div>
                                            </div>
                                        </div>
                                        <div><br /></div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                Total Ongoing Scenario
                                            </div>
                                            <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap" }}>
                                                <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                                    <a style={{ paddingLeft: "4%" }} className="text-left">
                                                        <img src={darkGreenCircle} /> Completed : {this.state.chart[0]}
                                                        {/* { this.props.type === "passenger" ? "Highway Pilot" : "Hub - Hub" } */}
                                                    </a>
                                                </div>
                                            </div>
                                            <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap", paddingRight: '2%' }}>
                                                <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                                    <a style={{ paddingLeft: "4%" }} className="text-left">
                                                        <img src={darkPurpleCircle} /> Processing : {this.state.chart[1]}
                                                        {/* { this.props.type === "passenger" ? "Urban Pilot" : "Parking Assist" } */}
                                                    </a>
                                                </div>
                                            </div>
                                            <div style={{ color: "#464646", display: "inline-block", whiteSpace: "nowrap", paddingRight: "2%" }}>
                                                <div style={{ paddingTop: "2%", paddingBottom: "2%" }}>
                                                    <a style={{ paddingLeft: "4%" }} className="text-left">
                                                        <img src={lightGreenCircle} /> Pending : {this.state.chart[2]}
                                                        {/* { this.props.type === "passenger" ? "Valet Parking" : "Auto-Docking" } */}
                                                    </a>
                                                </div>
                                            </div>
                                            <div>
                                                <canvas id="featureChart" style={{ width: "400px", height: "400px" }} ref={this.canvasRef} />
                                            </div>
                                        </div>
                                        <div><br /></div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card" style={{ display: "none" }}>
                                            <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                Simulation Time in Sequence / Time Elapsed:
                                            </div>
                                            <div className="card-body" id="welcome-card" style={{ textAlign: "center" }}>
                                                <p className="card-text" id="value">{this.state.current_time}</p>
                                                {/* <p className="card-text" id="value">Total Simulation Time (expected) : {} minutes = {} hours</p> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6" style={{ display: "none" }}>
                                        <div className="card">
                                            <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                Execution Time in Real Time:
                                            </div>
                                            <div className="card-body" id="welcome-card" style={{ textAlign: "center" }}>
                                                <p className="card-text" id="value">{this.state.exec_time_min} minutes</p>
                                                <p className="card-text" id="value">{this.state.exec_time_hrs} hours = {this.state.exec_time_days} days (approx.)</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div><br /></div>
                <div><br /></div>
            </div>
        )
    }
}

export default apm_dashboard